import View from './View';
import { MODAL_CLOSE_SEC, TIMEOUT_SEC } from '../config.js';
import logo from 'url:../../../src/img/logo.png';

class ForgotPasswordView extends View {
  _parentElement = document.querySelector('.main');

  _errorMessage = 'Forgot password Error Message';
  _message = 'Forgot password Success Message';

  addHandlerForgotPassword(handler) {
    let reset;
    this._parentElement.addEventListener('click', function (e) {
      reset = e.target.closest('.btn--reset');
      if (!reset) return;

      const formForgot = document.querySelector('.user-cred__form--forgot');
      formForgot.addEventListener('submit', function (e) {
        e.preventDefault();
        reset.disabled = true;
        reset.textContent = 'Sending reset link...'; // Update text for feedback
        const dataArr = [...new FormData(this)];
        const data = Object.fromEntries(dataArr);

        handler(data);
        setTimeout(() => {
          reset.disabled = false;
          reset.textContent = 'Reset Password'; // Update text for feedback
        }, MODAL_CLOSE_SEC * 1000);
      });
    });
  }

  _generateMarkup() {
    return `
          <div class="row user-cred">
        <div class="user-cred__head">
          <h1 class="user-cred__heading">Recover Password</h1>
        </div>
        <div class="user-cred__container">
          <div class="user-cred__logo">
            <div class="user-cred__logo--img">
              <img src="${logo}" alt="Pragya Enterprises Logo" />
            </div>
            <h3 class="user-cred__title"></h3>
            <p class="paragraph user-cred__description">
              For every student, every classroom.<br />
              Real uniforms.
            </p>
          </div>
          <div class="user-cred__form--container">
            <form
              action="#"
              class="user-cred__form user-cred__form--forgot"
              name="userCredForm"
              autocomplete="off"
            >
              <!-- EMAIL -->
              <div class="user-cred__email label-input">
                <label for="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="hello@pragya.enterprises"
                  name="email"
                  autofocus
                  required
                />
              </div>

              <div class="user-cred__terms">
                <input
                  type="checkbox"
                  id="terms"
                  class="user-cred__terms--check"
                  required
                />
                <label class="user-cred__terms--label" for="terms"
                  >I agree with <a href="/terms" style="text-decoration: none; color: #0066fb" target="_blank"> Terms & Conditions.</a></label
                >
              </div>
              <div class="user-cred__btn--container">
                <button type="submit" class="btn btn--new-pass btn--reset">
                  Reset Password
                </button>
              </div>
            </form>
          </div>
        </div>
        
      </div>
    </main>
    `;
  }
}

export default new ForgotPasswordView();
